<div class="steps-container">
    <div class="logo">
        <img class="logo-chubb" src="{{logo}}" alt="CHUBB">
    </div>
    <app-e-delivery [edeliveryData]="edeliveryContent"></app-e-delivery>
    <div class="date-time">
        <p>Electronic Signature: {{ getInitials }}</p>
        <p>Email of signer: {{emailaddress}}</p>
        <p>Date: {{ dateTime }} </p>
    </div>
</div>
